//

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';

@Injectable()
export class MdConnectorCluGhostModeFnZTicketVaultDocumentsService {

    constructor(
        private httpClient: HttpClient,
        private apiService: ApiService
    ) {
    }
    
    doRunZVaultTicketDocumentChecksProcess_Session(_checkParams : any){
        return this.httpClient.post(this.apiService.endPointsFO.doRunZVaultTicketDocumentChecksProcess_Session, _checkParams);
    }
    
    doSyncZVaultTicketDocumentItem_Session(_zVaultTicketDocumentItem : any){
        return this.httpClient.post(this.apiService.endPointsFO.doSyncZVaultTicketDocumentItem_Session, _zVaultTicketDocumentItem);
    }
}